import { createSelector } from '@reduxjs/toolkit';
import { GlobalState } from 'types/state';
import { AccountType } from 'types';

export const selectAccountSearchTerm = createSelector(
  (state: GlobalState) => state.account,
  (account: AccountType) => account.accountSearchState,
);

export const selectIsAccountLoading = createSelector(
  (state: GlobalState) => state.account,
  (account: AccountType) => account.isLoading,
);

export const selectSelectedAccountTableItem = createSelector(
  (state: GlobalState) => state.account,
  (account: AccountType) => account.accountTable.selectedProduct,
);

export const selectAccountTableItems = createSelector(
  (state: GlobalState) => state.account,
  (account: AccountType) => account.accountTable.tableItems,
);

export const selectAccountNumber = createSelector(
  (state: GlobalState) => state.account,
  (account: AccountType) => account.accountNumberFromParam,
);

export const selectAccountError = createSelector(
  (state: GlobalState) => state.account,
  (account: AccountType) => account.error,
);

export const selectAccountDetails = createSelector(
  (state: GlobalState) => state.account,
  (account: AccountType) => account.accountDetails,
);

export const selectBrUid = createSelector(
  (state: GlobalState) => state.account,
  (account: AccountType) => account.brUid,
);
